import src from "./bubble.svg"

const width = 16
const height = 17
export default { src, width, height }
